import React, { useState, useEffect } from 'react'
import { Moment } from 'moment'
import Grid from '@material-ui/core/Grid'
import { ResponsiveContainer } from 'recharts'

import { useApiCall } from 'hooks'
import { ERRORS } from 'consts'
import { snackbar } from 'components'

import {
  GetDataUserStatusDashboadResponse,
  DataUserStatusDashboad,
  ParametersDownload,
} from '../types'
import { getUserStatus } from '../api'
import { CustomPieChart } from './CustomPieChart'
import { useStyles } from '../styles'

const USER_STATUS = {
  NOT_YET: 'NOT_YET',
  NEW: 'NEW',
  WE_MISS_YOU: 'WE_MISS_YOU',
  RECOVERED: 'RECOVERED',
  RECURRENT: 'RECURRENT',
  LOST: 'LOST',
}

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
}

interface ChartData {
  name: string
  value: number
}

const ActiveVsInactiveUser: React.FC<propsUsersStatus> = ({ startDate, endDate }) => {
  const classes = useStyles()
  const [requestUsersTags] = useApiCall<ParametersDownload, GetDataUserStatusDashboadResponse>(() =>
    getUserStatus({ startDate, endDate }),
  )
  const [activeVsInactive, setActiveVsInactive] = useState<ChartData[]>([])
  const [actives, setActives] = useState<DataUserStatusDashboad[] | []>([])
  const [inactives, setInactives] = useState<DataUserStatusDashboad[] | []>([])

  useEffect(() => {
    requestUsersTags({ startDate, endDate })
      .then(resp => {
        const activeUsers: Array<DataUserStatusDashboad> = []
        const inactiveUsers: Array<DataUserStatusDashboad> = []
        activeUsers.push(resp.data.find(obj => obj.code === USER_STATUS.RECURRENT)!)
        activeUsers.push(resp.data.find(obj => obj.code === USER_STATUS.NEW)!)
        activeUsers.push(resp.data.find(obj => obj.code === USER_STATUS.RECOVERED)!)
        setActives(activeUsers.filter(obj => obj.value > 0))
        inactiveUsers.push(resp.data.find(obj => obj.code === USER_STATUS.WE_MISS_YOU)!)
        inactiveUsers.push(resp.data.find(obj => obj.code === USER_STATUS.LOST)!)
        inactiveUsers.push(resp.data.find(obj => obj.code === USER_STATUS.NOT_YET)!)
        setInactives(inactiveUsers.filter(obj => obj.value > 0))
        const countActives = activeUsers
          .map(obj => obj.value)
          .reduce((accumulator, number) => {
            return accumulator + number
          })
        const countInactives = inactiveUsers
          .map(obj => obj.value)
          .reduce((accumulator, number) => {
            return accumulator + number
          })
        setActiveVsInactive(
          [
            { name: 'Activos', value: countActives },
            { name: 'Inactivos', value: countInactives },
          ].filter(obj => obj.value > 0),
        )
      })
      .catch(() => {
        setActives([])
        setInactives([])
        setActiveVsInactive([])

        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate])

  return (
    <ResponsiveContainer width="100%">
      <Grid
        container
        item
        md={12}
        style={{ paddingTop: 20, paddingBottom: 20 }}
        className={classes.chartBody}
      >
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={activeVsInactive} title="Activos vs Inactivos" />
        </Grid>
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={actives} title="Activos" />
        </Grid>
        <Grid item md={4}>
          {' '}
          <CustomPieChart data={inactives} title="Inactivos" />
        </Grid>
      </Grid>
    </ResponsiveContainer>
  )
}
export { ActiveVsInactiveUser }
